mutation RotateCCBillWebhookSecret {
  rotateCCBillWebhookSecret {
    id
    paymentSettings {
      ccbill {
        webhookUrl
      }
    }
  }
}
